import { createContext, useContext } from 'react';

/**
 * True only inside the swipe-up bottom sheet (the FF-gated PREFERRED drawer,
 * see `PreferredPaymentDrawerView`). It lets deep descendants adapt to the
 * minimal white sheet WITHOUT prop-drilling through the generic
 * `Payment` / `PaymentMethodForm` pipeline:
 *   - `Details` renders its totals-first, background-less, dark-text layout.
 *   - the saved-card / saved-PayPal rows drop the account "⋮" (change/delete)
 *     menu — the sheet is a one-tap card; card management lives on the DEFAULT
 *     flow behind "Use Other Payment Method".
 *
 * Defaults to `false`, so every non-drawer surface (DEFAULT / SINGLE / the
 * PREFERRED modal) renders exactly as before.
 */
export const BottomSheetContext = createContext(false);

export const useIsBottomSheet = () => useContext(BottomSheetContext);
